// /app/bizhub 配下。サブシステム追加 = ルートファイルを 1 つ足して children に展開するだけ。
import jobRoutes from "./jobs";
import partyRoutes from "./parties";
import inventoryRoutes from "./inventory";
import equipmentRoutes from "./equipment";
import feedbackRoutes from "./feedback";
import settingsRoutes from "./settings";

// メニューの並び = サブシステムの並び（ダッシュボードのカードも同じ順）
const children = [...jobRoutes, ...partyRoutes, ...inventoryRoutes, ...equipmentRoutes, ...feedbackRoutes, ...settingsRoutes];

export const bizhubRoute = {
  path: "bizhub",
  component: () => import("@/views/Bizhub/BizhubLayout.vue"),
  meta: { requiresAuth: true, requiresBizhub: true },
  children: [
    { path: "", name: "BizhubHome", component: () => import("@/views/Bizhub/DashboardView.vue"), meta: { requiresAuth: true, requiresBizhub: true } },
    ...children,
  ],
};

// 横メニュー: [{ title: "案件", items: [{ title, to }] }]。項目が 1 つのグループ（在庫管理・フィードバック）は ▾ 無しのボタンになる（BizhubLayout）
export function buildBizhubMenu() {
  const groups = [];
  for (const r of children) {
    const m = r.meta?.menu;
    if (!m) continue;
    let g = groups.find((x) => x.title === m.group);
    if (!g) {
      g = { title: m.group, items: [] };
      groups.push(g);
    }
    g.items.push({ title: m.title, to: { name: r.name }, order: m.order ?? 0 });
  }
  for (const g of groups) g.items.sort((a, b) => a.order - b.order);
  return groups;
}
